export const UPDATE_STORE_DATA = "UPDATE_STORE_DATA";
export const UPDATE_STORE = "UPDATE_STORE";
export const REMOVE_STORE_DATA = "REMOVE_STORE_DATA";
export const UPDATE_STORE_ITEMS_LIST = "UPDATE_STORE_ITEMS_LIST";